import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Papa from 'papaparse';
import './projects.css';

// Define your human-readable titles
const HUMAN_TITLES = [
  'mDoc VC Format Support in Inji Certify',
  'Mifos Gazelle Runtime GUI',
  'AI-Generated TestCases for AMRIT Springboot Microservices .',
  'Saral Auto – Data Integration & Dashboard',
  'Scheme Training Discovery Microservice for Open Networks',
  'Decentralised Smart Mobility and Road Safety Platform'
];

// Normalize them for matching
const normalize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

const TARGET_TITLES = HUMAN_TITLES.map(normalize); // ✅ NOW THEY MATCH THE CSV KEYS

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/test5.csv')
      .then(res => {
        if (!res.ok) throw new Error('CSV fetch failed');
        return res.text();
      })
      .then(csvText => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const rows = results.data.map((row, idx) => ({ ...row, _id: idx + 1 }));

            const titleToRow = {};
            rows.forEach(row => {
              const raw = row['project title'] || '';
              const norm = normalize(raw);
              titleToRow[norm] = row;
            });

            const matched = TARGET_TITLES.map(target => titleToRow[target] || null)
              .filter(Boolean);

            if (matched.length !== 6) {
              console.warn(`⚠️ Only ${matched.length} of 6 target projects found in CSV`);
              console.log('Missing targets:', TARGET_TITLES.filter(t => !matched.some(m => normalize(m['project title']) === t)));
            }

            setProjects(matched);
          },
          error: (err) => console.error('CSV parse error:', err)
        });
      })
      .catch(err => console.error('Fetch error:', err));
  }, []);

  const visibleCards = 4;
  const totalDots = Math.ceil(projects.length / visibleCards);

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const cardWidth = 286 + 32;
    const index = Math.round(scrollRef.current.scrollLeft / (cardWidth * visibleCards));
    setActiveIndex(Math.min(index, totalDots - 1));
  };

  const scrollToIndex = (idx) => {
    if (!scrollRef.current) return;
    const cardWidth = 286 + 32;
    scrollRef.current.scrollTo({
      left: idx * cardWidth * visibleCards,
      behavior: 'smooth'
    });
  };

  const handleViewAllProjects = () => navigate('/projects');

  const openProject = (row) => {
    window.scrollTo({ top: 0, behavior: 'instant' }); // Scroll to top instantly
    navigate(`/project/${row._id}`, { state: { project: row } });
  };

  return (
    <div className="projects-section">
      <h2 className="projects-title">Top Projects from DMP 2025</h2>

      <div className="projects-list-scroll" ref={scrollRef} onScroll={handleScroll}>
        {projects.map(row => (
          <div className="project-card" key={row._id} onClick={() => openProject(row)}>
            <div className="project-card-bg">
              <img src={row['org logo']} alt="org logo" className="project-logo" loading="lazy" />
              <div className="project-gradient"></div>
            </div>
            <div className="project-info">
              <div className="project-name">{row['project title']}</div>
              <div className="project-contributor">
                Contributor: {row['contributor name']}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="projects-scroll-indicators">
        {Array.from({ length: totalDots }).map((_, i) => (
          <div
            key={i}
            className={`projects-dot${activeIndex === i ? ' active' : ''}`}
            onClick={() => scrollToIndex(i)}
          />
        ))}
      </div>

      <div className="view-all-projects-wrapper">
        <button className="view-all-projects-btn" onClick={handleViewAllProjects}>
          <span className="arrow">→</span> View All Projects
        </button>
      </div>
    </div>
  );
};

export default Projects;